import { memo, useMemo } from "react";
import { Flex, Box, Image, Text, useMantineTheme } from "@mantine/core";
import { getTimeInAMPMFormat } from "src/utils/dateHelper";
import { ICheckInManyQuery } from ".";
import { useAppContext } from "src/api/AppContext";
import { getStatusObj } from "..";

type IPropsExpandView = {
  detail: ICheckInManyQuery[0];
};
function ExpandView({ detail }: IPropsExpandView) {
  const theme = useMantineTheme();
  const { client, isAccepted } = detail || {};
  const { currentLocation } = useAppContext();

  const statusObj = useMemo(
    () =>
      getStatusObj(
        client?.memberships || [],
        currentLocation?.id,
        theme,
        isAccepted
      ),
    [client, currentLocation]
  );

  if (!client) return <></>;
  return (
    <Box
      sx={{
        background: statusObj?.color,
        padding: "6px 10px 8px",
        textAlign: "center",
      }}
    >
      <Text size={18} fw={500} sx={{ lineHeight: 0.8 }}>
        {client.user.firstName} {client.user.lastName}
      </Text>
      <Flex sx={{ justifyContent: "space-between" }}>
        <Text size={14} fw={500}>
          {client.memberStatus} {client.leadStatus && `- ${client.leadStatus}`}
        </Text>
        <Text size={14}>
          {getTimeInAMPMFormat(new Date(detail.createdDate))}
        </Text>
      </Flex>

      <Image
        mt={3}
        width={"100%"}
        height={200}
        src={client.user.profilePicUrl || ""}
        alt="profile Image"
        withPlaceholder
        radius={4}
      />
    </Box>
  );
}

export default memo(ExpandView);
